import angular from 'angular';
import uirouter from 'angular-ui-router';
import routing from './routes';

import EditMatchController from './EditMatchController';


import panel from '../../services';

export default angular.module('app.editMatch', [uirouter, panel])
    .config(routing)
    .controller('EditMatchController', EditMatchController)
    .name;



// WEBPACK FOOTER //
// ./src/app/features/edit-match/index.js